<a routerlink="/" (click)="_click()" class="logo-link">
  <figure class="logo {{classCustom}}">  
    <img width="100px" height="50px" [src]="logo" alt="Logo" />
  </figure>
</a> 

  